/* istanbul ignore next */
const ACTIONS = {
    GET_VAT_METADATA_SUCCESS: 'GET_VAT_METADATA_SUCCESS',
    SET_VAT_FIELD: 'SET_VAT_FIELD',
    UPDATE_VAT_DETAILS: 'UPDATE_VAT_DETAILS',
    VAT_SERVICE_ERROR: 'VAT_SERVICE_ERROR',
    SET_FIELD_ERROR: 'SET_FIELD_ERROR',
    ENABLE_VAT_CONTINUE_BUTTON: 'ENABLE_VAT_CONTINUE_BUTTON',
    GET_VAT_METADATA: 'GET_VAT_METADATA',
    INFO_ICON_CLICKED: 'INFO_ICON_CLICKED',
    GET_VAT_REGION_CODE: 'GET_VAT_REGION_CODE'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    getVatMetadataSuccess(vatMetadata) {
        return {
            type: ACTIONS.GET_VAT_METADATA_SUCCESS,
            payload: {
                vatMetadata
            }
        };
    },

    getVatMetadata() {
        return {
            type: ACTIONS.GET_VAT_METADATA
        };
    },

    getVatRegionCodes(selectedCountry, regionCodeList) {
        return {
            type: ACTIONS.GET_VAT_REGION_CODE,
            payload: {
                selectedCountry,
                regionCodeList
            }
        };
    },

    toggleInfoIcon(infoIconClickedStatus) {
        return {
            type: ACTIONS.INFO_ICON_CLICKED,
            payload: {
                infoIconClickedStatus
            }
        };
    },

    setVatField(fieldName, fieldValue) {
        return {
            type: ACTIONS.SET_VAT_FIELD,
            payload: {
                fieldName,
                fieldValue
            }
        };
    },

    updateVatDetails(vatDetails) {
        return {
            type: ACTIONS.UPDATE_VAT_DETAILS,
            payload: {
                vatDetails
            }
        };
    },

    setFieldError(field, msg) {
        return {
            type: ACTIONS.SET_FIELD_ERROR,
            payload: {
                field,
                msg
            }
        };
    },

    enableContinueButton() {
        return {
            type: ACTIONS.ENABLE_VAT_CONTINUE_BUTTON
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.VAT_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
